import { createClient } from "@librus/api-client";

const unauthorizeHandler = () => {
  throw new Error("not autorized");
};

const configClient = createClient("", unauthorizeHandler, fetch);

export default configClient;
